/**
 * A logger exposes the console.*
 * methods and provides a simple way to
 * change out what should happen in the case of an error
 * in multiple levels of the tree.
 */

/**
 * Different Log Levels
 */
// numerical representation, lower is a higher level
function levelToNumber(level) {
  switch (level) {
    case 'error':
      return 1;

    case 'warn':
      return 2;

    case 'log':
      return 3;

    case 'info':
      return 4;

    case 'debug':
      return 5;
  }
}
/**
 * Compares to levels
 * @returns 0 if levels are the same, -1 if level1 is a higher level then level2, otherwise 1
 */


export function compareLevels(level1, level2) {
  var l1 = levelToNumber(level1);
  var l2 = levelToNumber(level2);

  if (l1 === l2) {
    return 0;
  }

  if (l1 < l2) {
    return -1;
  }

  return 1;
}